import React from 'react';
import { FaBox } from 'react-icons/fa';

const PickupAddressDisplay = () => {
  return (
    <div className="mt-3 bg-gray-50 p-4 rounded-md border border-gray-200">
      <div className="flex items-center mb-2">
        <FaBox className="mr-2 text-gray-700" size={18} />
        <h4 className="text-sm font-medium">Адрес на магазина:</h4>
      </div>
      <p className="text-sm text-gray-700">ул. Княз Борис 98</p>
      <p className="text-sm text-gray-700">Стара Загора, 6000</p>
    </div>
  );
};

export default PickupAddressDisplay; 